module.exports = __webpack_public_path__ + "img/1 (140).23610ae9.png";